export const addressApi = {
  baseURL: `${process.env.VUE_APP_ADDRESS_API_URL}`,
  headers: {
    'X-Api-Key': `${process.env.VUE_APP_ADDRESS_API_KEY}`,
  },
  hasCustomConfig: true,
};
